export function optionFaqLabel(option) {
    console.log('optionFaqLabel', option);
    if (option._source.domanda) {
        return option._source.domanda;
    } else return ''
}

export function optionFaqAdminLabel(option) {
    return `${option['firstname']} ${option['lastname']}`;
}